export enum PrintType {
    TICKET = 1,
    RESUME,
    NONE,
    GROUPED_RESUME,
    SIMPLE_RESUME,
}
